import React from "react"
import Layout from "../components/layout"

export default () => (
<Layout>
  <div>
    <h1>I'd love to talk! Email me at the address below</h1>
    <p>
      <a href="mailto:akoleajit@gmail.com" style={{ textShadow: `none` }} color = "white">akoleajit@gmail.com</a>
    </p>
  </div>
  </Layout>
)